import cs from 'classnames';
import React from 'react';
import { CloseIcon } from '../../../ui/icons/CloseIcon/CloseIcon';
import classNames from './CloseIconButton.module.scss';

interface InfoButtonIcon {
    className?: string;
    onClick?: () => void;
    width?: string;
    height?: string;
    color?: string;
}

export function CloseIconButton(props: InfoButtonIcon) {
  const {
    className,
    onClick,
    width = '100%',
    height = '100%',
    color = 'white',
  } = props;

  return (
    <button
      type="button"
      className={cs(classNames.button, className)}
      onClick={onClick}
    >
      <CloseIcon width={width} height={height} fill={color} />
    </button>
  );
}
